import React from 'react';
import Layout from '@/components/layout/Layout';
import CM1Report from '@/components/reports/CM1Report';

const CM1ReportPage: React.FC = () => {
  return (
    <Layout>
      <CM1Report />
    </Layout>
  );
};

export default CM1ReportPage;
